import styled from 'styled-components';
import breakpoint from '../breakpoints';

export const Wrapper = styled.div`
  margin: 0 auto;
  ${breakpoint('mobile', 'down')}{
    width: 100%;
  }
`

export const PatentsSection = styled.section`
  width: 80%;
  max-width: 1440px;
  margin: 0 auto;
  text-align: left;
  background-color: #f1f1f1;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  height: 100%;
  padding-bottom: 20px;
  & > div {
    display: flex;
    flex: 0 0 calc(33.333333% - 90px);
    align-self: stretch;
  }
  ${breakpoint('tablet', 'down')} {
    & > div {
      display: flex;
      flex: 0 0 calc(50% - 90px);
      align-self: stretch;
    }
  }
  ${breakpoint('mobile', 'down')} {
    width: 100%
    flex-direction: column;
    & > div {
      display: flex;
    }
  }
`

export const Patent = styled.div`
  padding: 25px;
  float: left;
  margin: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  -webkit-box-shadow: 9px 9px 18px -13px rgba(0,0,0,0.75);
  -moz-box-shadow: 9px 9px 18px -13px rgba(0,0,0,0.75);
  box-shadow: 9px 9px 18px -13px rgba(0,0,0,0.75);
  ${({ie}) => {
    if (ie === "true") {return 'width: 100%;'}
  }}
  
  ${breakpoint('mobile', 'down')}{
    margin: 14px 20px 14px 20px;
  }
`

export const Heading = styled.div`
  ${breakpoint('tablet', 'up')}{
  }
  ${breakpoint('tablet', 'down')} {
  }
`

export const PatentNumber = styled.span`
  font-family: "ToyotaType Bold";
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.05em;
`

export const PatentTitle = styled.h3`
  font-family: "ToyotaType Bold";
	letter-spacing: 0.025em;
	line-height: 30px;
	margin-bottom: 15px;
  font-size: 24px;
  ${breakpoint('tablet', 'down')} {
    margin: 0;
  }
  ${breakpoint('mobile', 'down')}{
    padding-bottom: 20px;
  }
`
export const PatentBody = styled.div``

export const Description = styled.p`
  font-family: "ToyotaType Book";
	font-size: 13px;
	line-height: 20px;
	letter-spacing: 0.05em;
`

export const PatentFooter = styled.div`
  margin-top: auto;
`

export const DetailsLink = styled.div`
  font-family: 'ToyotaType Semibold';
  font-weight: bold;
  color: #CC0000;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    color: #990000;
  }
`